module.exports = __webpack_public_path__ + "img/Icon-external-link -dark.c03a6b77.svg";